import { tokenExpiredSync } from "../routes/AuthRoutesProvider";
import { POST } from "../apis/base.api";
import { clearWeddingSessionContext } from "./clientstorage";

export const logout = async () => {
  await POST({ ext: "auth/signout" });
  tokenExpiredSync();
  clearWeddingSessionContext();

  window.location.href = "/login";
  window.location.reload();
};
